module.exports = __webpack_public_path__ + "img/1-2.003eda13.png";